// Satu penilai "nomor HP ini lengkap atau belum". Sebelum ini tiap form punya salinan
// `/^\+[0-9]+$/` sendiri — pola itu meloloskan "+628", yaitu tepat yang terjadi saat nomor
// masih setengah diketik: form tampak terisi, tombol lanjut hidup, padahal nomornya belum ada.
//
// Panjang minimal saja tak cukup ("+12345678" lolos tapi bukan nomor siapa-siapa), jadi
// keputusannya diserahkan ke libphonenumber-js yang MEMANG sudah terpasang (dipakai
// MazPhoneNumberInput di form yang sama) — bukan dependency baru.
import { getCountryCallingCode, isValidPhoneNumber } from "libphonenumber-js";

export function isCompletePhoneNumber(value) {
    const phone = String(value ?? "").trim();
    if (!phone.startsWith("+")) return false; // simpanan kita selalu E.164; "08xx" belum dinormalkan
    try {
        return isValidPhoneNumber(phone);
    } catch {
        return false;
    }
}

// "ID" -> "+62". Dipakai selektor negara yang menampilkan nama negara sekaligus kodenya
// (maz-ui hanya sanggup menampilkan salah satu di selektor tertutup).
export function dialCodeOf(iso2) {
    try {
        return `+${getCountryCallingCode(String(iso2 || "").toUpperCase())}`;
    } catch {
        return "";
    }
}
